module.exports = __webpack_public_path__ + "img/icon-xiangxijiaocheng@2x.9fb1b061.png";